module.exports = __webpack_public_path__ + "static/media/yunjiadajianshan_web.bb2102ce.webp";